'use client';

import { cn } from '@ngg/storefront-utils';
import { Menu as HeadlessMenu } from '@headlessui/react';
import { useMemo } from 'react';
import type { SortingOptions } from '@ts/sort';
import Icon from '../../../icon/icon';
import * as styles from './SortBy.styles';
import { SortValues } from '@business/gql/graphql';

type Props = {
  options: SortingOptions;
  value: SortValues;
  onChange: (payload: SortValues) => void;
  openSortingDrawer?: () => void;
  isMobile?: boolean;
  classNames?: {
    openButton?: string;
    items?: string;
  };
};

export default function SortBy(props: Props) {
  const { openSortingDrawer, value, options, onChange, isMobile, classNames } =
    props;

  const actualValue = useMemo(
    () => options.find((opt) => opt.id === value),
    [options, value],
  );

  return (
    <div className={styles.container()}>
      <HeadlessMenu as="div" className={styles.menu()}>
        <HeadlessMenu.Button
          className={({ open }) =>
            cn(
              styles.menuButton(),
              open && styles.menuButtonOpen(),
              open && classNames?.openButton,
            )
          }
          onClick={openSortingDrawer}>
          {({ open }) => (
            <>
              <span className={styles.label()}>{actualValue?.label}</span>{' '}
              <Icon
                name="downArrow"
                color="black"
                className={cn(
                  styles.icon(),
                  open && !isMobile && styles.iconOpen(),
                )}
              />
            </>
          )}
        </HeadlessMenu.Button>

        <HeadlessMenu.Items
          as="ul"
          className={cn(styles.itemsList(), classNames?.items)}>
          {options.map((option) => (
            <HeadlessMenu.Item as="li" key={option.id}>
              <button
                type="button"
                onClick={() => onChange(option.id)}
                className={cn(
                  styles.item(),
                  value === option.id && 'underline',
                )}>
                {option.label}
              </button>
            </HeadlessMenu.Item>
          ))}
        </HeadlessMenu.Items>
      </HeadlessMenu>
    </div>
  );
}
